
import { Component, OnInit,Input,ElementRef,ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators,NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { Usuario } from 'src/app/interfaces/interfaces';
import {Router} from '@angular/router';


@Component({
  selector: 'app-modal-usuario-edicion',
  templateUrl: './modal-usuario-edicion.component.html',
  styleUrls: ['./modal-usuario-edicion.component.scss']
})
export class ModalUsuarioEdicionComponent implements OnInit {
  formUsuariosEditar: FormGroup;
  rolesUsuario: { id_Rol: number; nombre_rol: string; }[];
  rolesSeleccionados: string[] = [];
  @Input() emailUsuario: string;
  //Variable que el usuario vendra de afuera
  @Input() usuario: Usuario;
  @Input() email_usuario: string;
  mostrarFormularioEditar: boolean = false;


  @ViewChild('contenedorRoles', { static: true }) checks: ElementRef;
  usuarios:any;

  get fce() { // acceso a los controles de las form para editar usuarios
    return this.formUsuariosEditar.controls;
  }

  get fe() { // acceso a la form para editar usuarios
    return this.formUsuariosEditar;
  }

  constructor(
    private dataService: DataService,
    private notifier: NotifierService,
    private router:Router
  ) { }

  ngOnInit() {
    this.formUsuariosEditar = new FormGroup({
      email_usuario: new FormControl(''),
      Roles: new FormControl('', [Validators.required]),
      nombre_usuario: new FormControl('', [Validators.required]),
      dep_usuario: new FormControl('', [Validators.required]),
      direccion_areaUsuario: new FormControl('', [Validators.required]),
      vip_usuario: new FormControl(0, [Validators.required]),
      puesto_usuario: new FormControl('', [Validators.required]),
      estatus_usuario: new FormControl(1, [Validators.required]),
      telefono_usuario: new FormControl(''),
      extension_usuario: new FormControl(''),
      usuarioModifica: new FormControl(this.emailUsuario)
    });

    this.cargarInfoUsuarios();
  }


  ngAfterViewInit()
  {
    let usr = Array.from(this.checks.nativeElement.children);
      usr.forEach((rol: any) => {
        if (rol.children[0].checked) {
          rol.children[0].click();
        }
      }); 
      this.usuarios=usr;
  }


  verUsuario()
  {
    this.mostrarFormularioEditar=true;
    this.router.navigate(['./update-usuario', this.emailUsuario])
   // this.cargarInfoUsuarios();

  }

  agregarQuitarRol(rol: string) {
    let index = this.rolesSeleccionados.indexOf(rol);
    if (index !== -1) {
      this.rolesSeleccionados = this.rolesSeleccionados.filter(el => el !== rol);
    } else {
      this.rolesSeleccionados.push(rol);
    }
      this.formUsuariosEditar.patchValue({
        Roles: this.rolesSeleccionados.toString()
      });
  }


  //Funcion para cargar la informacion del usuario
  cargarInfoUsuarios() 
  {
    let cuenta=this.email_usuario;

    if (cuenta !== '') {
      this.dataService.obtenerInfoUsuario(cuenta).subscribe(res => {
        if (res['errorMessage']) {
          this.notifier.notify('error', 'Ha ocurrido un error al intentar obtener la información del usuario. Revisa tu conexión de red e inténtalo nuevamente más tarde.');
        } else {
          let infoUser: Usuario = res['objData'];
         
          this.formUsuariosEditar.patchValue({
            Roles: infoUser.roles,
            nombre_usuario: infoUser.nombre_usuario,
            puesto_usuario: infoUser.puesto_usuario,
            dep_usuario: infoUser.dep_usuario,
            vip_usuario: infoUser.vip_usuario,
            estatus_usuario: infoUser.estatus_usuario,
            direccion_areaUsuario:infoUser.direccion_areaUsuario
          });
         /*let usr = Array.from(this.checks.nativeElement.children);
            usr.forEach((rol: any) => {
            if (rol.children[0].checked) {
              rol.children[0].click();
            }
          }); */

         this.usuarios.forEach((rol: any) => {
            if (infoUser.roles.split(',').findIndex(x => x === rol.children[0].id) !== -1) {
              rol.children[0].click();
            }
          });

        }
      });
    } else {
      this.notifier.notify('error', 'Selecciona una cuenta valida.');
    }
  }


  editarUsuario() {
    this.dataService.editarUsuario(this.formUsuariosEditar.value).subscribe(res => {
      if (res['errorMessage']) {
        this.notifier.notify('error',
        'Ha ocurrido un error al intentar editar el usuario. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
      } else {
        this.notifier.notify('success', 'Usuario editado correctamente.');
        this.formUsuariosEditar.reset({ opcion: 2, vip: 0, estatus: 1 });
        //this.cargarUsuarios();
        //this.cargarSiguientes();
      }
    });
  }

}
